import { Config } from '@comall-backend-builder/core/lib/parser';

export let config: Config = {
    entities: {
        // 直播商品
        LiveProduct: {
            apiPath: '/loader/live-product',
            properties: {
                id: {
                    type: 'string',
                    displayName: 'id',
                },
                skuId: {
                    type: 'string',
                    displayName: 'ID',
                },
                skuCode: {
                    type: 'string',
                    displayName: 'SKU',
                },
                name: {
                    type: 'string',
                    displayName: '商品名称',
                },
                imgUrl: {
                    type: 'string.image.text',
                    displayName: '商品图片',
                },
                priceType: {
                    type: 'string',
                    displayName: '价格类型',
                },
                price: {
                    type: 'string',
                    displayName: '价格',
                },
                status: {
                    type: 'string.options.select',
                    displayName: '状态',
                    options: [
                        {
                            id: 'UNDER_REVIEW',
                            name: '审核中',
                        },
                        {
                            id: 'APPROVED',
                            name: '审核通过',
                        },
                        {
                            id: 'REJECTION',
                            name: '审核驳回',
                        },
                    ],
                },
            },
            filters: {
                name: {
                    type: 'string',
                    displayName: '商品名称',
                },
                skuCode: {
                    type: 'string',
                    displayName: 'SKU',
                },
                skuId: {
                    type: 'string',
                    displayName: 'ID',
                },
                status: {
                    type: 'string.options.select',
                    displayName: '审核状态',
                    options: [
                        {
                            id: 'UNDER_REVIEW',
                            name: '审核中',
                        },
                        {
                            id: 'APPROVED',
                            name: '审核通过',
                        },
                        {
                            id: 'REJECTION',
                            name: '审核驳回',
                        },
                    ],
                },
                skuList: {
                    type: 'string',
                    displayName: 'SKU',
                },
            },
        },
    },
    components: {
        LiveProductsPage: {
            component: 'Viewport',
        },

        LiveProductsView: {
            component: 'Card',
            entity: 'LiveProduct',
            content: {
                component: 'FlexLayout',
                direction: 'vertical',
                align: 'justify',
                items: [
                    {
                        component: 'LiveProductsFilter',
                    },
                    {
                        component: 'LiveProductsTable',
                    },
                ],
            },
        },

        LiveProductsFilter: {
            component: 'FilterFormPlus',
            direction: 'horizontal',
            labelCol: 8,
            style: {
                marginBottom: 16,
            },
            fields: [
                {
                    property: 'name',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'skuCode',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'skuId',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'status',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
            ],
            fieldRow: {},
            fieldCol: {
                span: 8,
            },
            footer: {
                style: {
                    textAlign: 'right',
                },
            },
            submit: {
                text: '查询',
            },
            reset: true,
        },

        AddLiveProduct: {
            component: 'Card',
            content: {
                component: 'LiveProductAdd',
            },
        },

        ModifyLiveProduct: {
            component: 'Card',
            content: {
                component: 'LiveProductModify',
            },
        },
    },
    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/live-product',
                    breadcrumbName: '直播管理',
                    component: 'LiveProductsPage',
                    childRoutes: [
                        {
                            path: '/add',
                            component: 'AddLiveProduct',
                            breadcrumbName: '添加商品',
                        },
                        {
                            path: '/modify/:id',
                            component: 'ModifyLiveProduct',
                            breadcrumbName: '更新商品',
                        },
                        {
                            path: '/',
                            component: 'LiveProductsView',
                            breadcrumbName: '直播商品管理',
                        },
                    ],
                },
            ],
        },
    ],
};
